import { IApplicationState } from '../../types/redux';

export const selectIsInfrastructureMapEnabled = (state: IApplicationState): boolean => {
  const { page } = state;

  return page.isInfrastructureMapEnabled;
};
